import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Root from '@components/root/Root'
import Button from '@components/button/Button'
import SimpleAlert from '@components/modal/SimpleAlert'

import Notification from './form/Notification'

import useI18n from '@i18n/useI18n'
import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'

import useNavigation from '@layout/useNavigation'

import api from '@api/api'

import logger from '@utils/logger'

const AccountNotificationScreen = () => {
  const i18n = useI18n()
  const navigation = useNavigation()

  const preferences = useReducer(UserStore.store, (s) => s.preferences.notifications)

  const [form, setForm] = React.useState<PreferenceNotificationRequest[]>(preferences)
  const [status, setStatus] = React.useState<Status>('loading')

  React.useEffect(() => {
    api.notifification
      .getPreferences()
      .then((res) => UserStore.actions.setPreferences({ notifications: res }))
      .catch(logger.error)
      .finally(() => setStatus('fetched'))
  }, [])

  const onSave = () => {
    // save to store
    UserStore.actions.setPreferences({ notifications: form })

    // save to serveur
    api.notifification
      .updatePreferences({ preferenceNotificationList: form })
      .then(() => {
        SimpleAlert.open({
          title: i18n.t('common.success'),
          description: i18n.t('screens.account.success'),
          buttons: [
            {
              label: i18n.t('common.ok'),
              onClick: () => {
                SimpleAlert.close()
                navigation.goBack()
              },
            },
          ],
        })
      })
      .catch((err) => {
        logger.error(err)
        SimpleAlert.open({
          title: i18n.t('common.errorTitle'),
          description: i18n.t('common.error'),
          buttons: [{ label: i18n.t('common.ok'), onClick: () => SimpleAlert.close() }],
        })
      })
  }

  const onForm = (vals: PreferenceNotificationRequest[]) => {
    setForm(vals)
    return Promise.resolve()
  }

  const renderFooter = () => {
    return (
      <Footer>
        <Button label={i18n.t('screens.account.mobileSave')} onClick={onSave} status="active" />
      </Footer>
    )
  }

  return (
    <Root
      loading={status === 'loading'}
      onLeft={navigation.goBack}
      header={i18n.t('screens.account.mobileSections.notification')}
      renderFixedBottom={renderFooter}
      fixed>
      <Notification form={form} onForm={onForm} />
    </Root>
  )
}

export default AccountNotificationScreen

const Footer = styled(View)`
  margin: 16px;
`
